"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _Comment = _interopRequireDefault(require("./Comment"));

var _immutable = require("immutable");

var DEFAULTS = {
  id: null,
  highlightStart: null,
  highlightEnd: null,
  highlightText: null,
  comments: new _immutable.List(),
  correlationId: null,
  updates: 0,
  // Dummy is a conversation created but w/ no comments (so it is "temporary")
  isEmptyDummy: false
};

var Conversation = /*#__PURE__*/function (_Record) {
  (0, _inherits2.default)(Conversation, _Record);

  function Conversation() {
    (0, _classCallCheck2.default)(this, Conversation);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Conversation).apply(this, arguments));
  }

  (0, _createClass2.default)(Conversation, null, [{
    key: "fromJS",
    value: function fromJS(data) {
      var comments = data.comments;
      return new Conversation({
        id: data.id,
        highlightStart: data.highlightStart,
        highlightEnd: data.highlightEnd,
        highlightText: data.highlightText,
        comments: new _immutable.List(comments ? comments.map(_Comment.default.fromJS) : []),
        correlationId: data.correlationId,
        isEmptyDummy: data.isEmptyDummy
      });
    }
  }]);
  return Conversation;
}((0, _immutable.Record)(DEFAULTS));

exports.default = Conversation;
module.exports = exports.default;